import { simpleMix } from '@entities/simple-mix';
import { warehouseModel } from '@entities/warehouse';
import { createGate, createStore, sample } from '@lib/state-engine';
import { ISimpleMixingBag, ISimpleMixingBags } from '@@/mixing/ts';
import { isValidBagId } from '@lib/bag-formatting';

export const PageGate = createGate();

export const $bags = createStore<ISimpleMixingBags>({ left: null, right: null }).reset(
  simpleMix.reset,
);

sample({
  clock: simpleMix.removeBag,
  source: $bags,
  fn: (bags, idOrDirection) => {
    const isId = isValidBagId(idOrDirection);

    if (isId && bags.left?.id === idOrDirection) return { ...bags, left: null };
    if (isId && bags.right?.id === idOrDirection) return { ...bags, right: null };

    return { ...bags, [idOrDirection]: null };
  },
  target: $bags,
});

sample({
  clock: simpleMix.$mixedBags,
  filter: (bags) => typeof bags[0] === 'string' && isValidBagId(bags[0]),
  fn: (bags) => bags[0] as string,
  target: warehouseModel.fetchBagByIdFx,
});
sample({
  clock: simpleMix.$mixedBags,
  source: $bags,
  filter: (bags, idsOrEntities) => typeof idsOrEntities[0] !== 'string',
  fn: (bags, idsOrEntities) => ({
    ...bags,
    left: idsOrEntities[0] as ISimpleMixingBag | null,
  }),
  target: $bags,
});

sample({
  clock: simpleMix.$mixedBags,
  filter: (bags) => typeof bags[1] === 'string' && isValidBagId(bags[1]),
  fn: (bags) => bags[1] as string,
  target: warehouseModel.fetchBagByIdFx,
});
sample({
  clock: simpleMix.$mixedBags,
  source: $bags,
  filter: (bags, idsOrEntities) => typeof idsOrEntities[1] !== 'string',
  fn: (bags, idsOrEntities) => ({
    ...bags,
    right: idsOrEntities[1] as ISimpleMixingBag | null,
  }),
  target: $bags,
});

sample({
  clock: warehouseModel.fetchBagByIdFx.doneData,
  source: { bags: $bags, idsOrEntities: simpleMix.$mixedBags },
  fn: ({ bags, idsOrEntities }, bag) => {
    if (bag.id === idsOrEntities[0]) return { ...bags, left: bag };
    if (bag.id === idsOrEntities[1]) return { ...bags, right: bag };

    return bags;
  },
  target: $bags,
});

sample({
  clock: warehouseModel.fetchBagByIdFx.failData,
  filter: PageGate.status,
  target: simpleMix.reset,
});
